import styles from './styles.module.scss';

export const NoItemsError = () => {
  const errorText = 'There is nothing to see here yet!';

  return (
    <section className={styles.screen} data-testid="no-items-error">
      <div className={styles.info}>
        <div className={styles.text}>{errorText}</div>
      </div>
    </section>
  );
};
